<script setup lang="ts">
import { cn } from '@/lib/utils'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { type HeadingVariants, headingVariants } from '.'

interface Props extends PrimitiveProps {
    variant?: HeadingVariants['variant']
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    as: 'p',
})
</script>

<template>
    <Primitive
        data-slot="button"
        :as="as"
        :as-child="asChild"
        :class="cn(headingVariants({ variant }), props.class)"
    >
        <slot />
    </Primitive>
</template>
